import React from 'react';

export const getTopRouteCategoryView = (data) => {
  let view = []
  let liView = []
  if (data && data.links && data.links.length) {
    for (let i in data.links) {
      const { src, dest, slug, type } = data.links[i];
      liView.push(
        <li key={src + dest + i + type}>
          <a href={slug ? `${__ENV_CONFIG__.__GOIBIBO__}${slug}` : ''} >{`${src} to ${dest} ${type} Bus`}</a>
        </li>
      )
    }
    if (liView && liView.length) {
      view.push(<ul key="topRouteCategory">{liView}</ul>)
    }
  }
  return { view, isDataPresent: view.length ? true : false }
}

export const getTopRouteCategoryOperatorView = (data) => {
  let view = []
  let liView = []
  if (data && data.links && data.links.length) {
    for (let i in data.links) {
      const { src, dest, slug } = data.links[i];
      liView.push(
        <li key={src + dest + i}>
          <a href={slug ? `${__ENV_CONFIG__.__GOIBIBO__}${slug}` : ''} >{`${src} to ${dest} Bus`}</a>
        </li>
      )
    }
    if (liView && liView.length) {
      view.push(<ul key="topRouteCategory">{liView}</ul>)
    }
  }
  return { view, isDataPresent: view.length ? true : false }
}

export const getOperatorView = (data) => {
  let view = []
  let liView = [];
  for (let index in data) {
    const { id, n, slug } = data[index];

    liView.push(
      <li key={id + n + index}>
        <a href={`${__ENV_CONFIG__.__GOIBIBO__}${slug}`} title={n}>{n}</a>
      </li>
    )
  }
  if (liView && liView.length) {
    view.push(<ul key={"topOperatorView"}>{liView}</ul>)
  }
  return { topOperatorView: view, isTopOperatorDataPresent: view.length ? true : false };
}

export const getBPDPView = (bp, dp) => {
  let bpView = [], dpView = [];
  let bpLiView = [], dpLiView = [];
  for (let i in bp) {
    bpLiView.push(
      <li key={bp[i]}>{bp[i]}</li>
    )
  }
  for (let i in dp) {
    dpLiView.push(
      <li key={dp[i]}>{dp[i]}</li>
    )
  }
  if (bpLiView && bpLiView.length) {
    bpView.push(<ul key="bpPoints">{bpLiView}</ul>)
  }
  if (dpLiView && dpLiView.length) {
    dpView.push(<ul key="bpPoints">{dpLiView}</ul>)
  }
  return { bpView, dpView, isBPPresent: bpView.length ? true : false, isDPPresent: dpView.length ? true : false }

}

export function getTopOperatorsView(data) {
  let view = []
  let liView = []
  if (data && data.links && data.links.length) {
    for (let i in data.links) {
      const { op_name, slug } = data.links[i];
      liView.push(
        <li key={op_name + i}>
          <a href={slug ? `${__ENV_CONFIG__.__GOIBIBO__}${slug}` : ''} >{op_name}</a>
        </li>
      )
    }
    if (liView && liView.length) {
      view.push(<ul key="topOperatorView">{liView}</ul>)
    }
  }
  return { view, isDataPresent: view.length ? true : false }
}

export const getTileView = (data) => {
  let view = []
  let liView = []
  const { title, links = [] } = data;
  if (links && links.length) {
    for (let i in links) {
      const { text, url = "" } = links[i];

      liView.push(
        <li key={text + i}>
          {url ? <a href={url} >{text}</a> : <span>{text}</span>}
        </li>
      )
    }
    if (liView && liView.length) {
      view.push(<ul key={`${title}_tileView`}>{liView}</ul>)
    }
  }
  return { view, isDataPresent: view.length ? true : false }
}

export const getHotelsView = (data) => {
  let view = []
  let liView = []
  if (data && data.length) {
    for (let i in data) {
      const { name, link = "" } = data[i];
      let modifiedLink = function () {
        let modifiedLink = link;
        if (link && link.length && link.indexOf("http") == -1) {
          modifiedLink = `https://${link}`
        }
        return modifiedLink;
      }()
      liView.push(
        <li key={name + i}>
          {modifiedLink ? <a href={modifiedLink || ''} >{name}</a> : <span>{name}</span>}
        </li>
      )
    }
    if (liView && liView.length) {
      view.push(<ul key="hotelsView">{liView}</ul>)
    }
  }
  return { view, isDataPresent: view.length ? true : false }
}

export const getTopRoutesView = (data) => {
  let view = []
  let liView = []
  if (data && data.links && data.links.length) {
    for (let i in data.links) {
      const { src, dest, slug } = data.links[i];
      liView.push(
        <li key={src + i + dest}>
          <a href={slug ? `${__ENV_CONFIG__.__GOIBIBO__}${slug}` : ''} >{`${src} to ${dest} Bus`}</a>
        </li>
      )
    }
    if (liView && liView.length) {
      view.push(<ul key="topRouteView">{liView}</ul>)
    }
  }
  return { view, isDataPresent: view.length ? true : false }
}


export const getCitiesNearView = (data) => {
  let view = []
  let liView = []
  if (data && data.links && data.links.length) {
    for (let i in data.links) {
      const { city_name, slug } = data.links[i];
      liView.push(
        <li key={city_name + i}>
          <a href={slug ? `${__ENV_CONFIG__.__GOIBIBO__}${slug}` : ''} >{city_name}</a>
        </li>
      )
    }
    if (liView && liView.length) {
      view.push(<ul key="topCitiesView">{liView}</ul>)
    }
  }
  return { view, isDataPresent: view.length ? true : false }
}
